import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import { API_BASE } from "../config";

/* --- Inline SVG icons (même style que Login.js) --- */
function Svg({ children, ...props }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="i" {...props}>
      {children}
    </svg>
  );
}

const Icons = {
  calendar: (p) => (
    <Svg {...p}>
      <path d="M7 2v3M17 2v3" />
      <path d="M3.5 9h17" />
      <path d="M6 6h12a2.5 2.5 0 0 1 2.5 2.5v11A2.5 2.5 0 0 1 18 22H6A2.5 2.5 0 0 1 3.5 19.5v-11A2.5 2.5 0 0 1 6 6z" />
    </Svg>
  ),
  mail: (p) => (
    <Svg {...p}>
      <path d="M4 6h16v12H4z" />
      <path d="M4 7l8 6 8-6" />
    </Svg>
  ),
  lock: (p) => (
    <Svg {...p}>
      <path d="M7 11V8a5 5 0 0 1 10 0v3" />
      <path d="M6 11h12v10H6z" />
    </Svg>
  ),
  shield: (p) => (
    <Svg {...p}>
      <path d="M12 2l7 4v6c0 5-3.5 9.5-7 10-3.5-.5-7-5-7-10V6l7-4z" />
      <path d="M9 12l2 2 4-5" />
    </Svg>
  ),
  eye: (p) => (
    <Svg {...p}>
      <path d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7-9.5-7-9.5-7z" />
      <path d="M12 15.2A3.2 3.2 0 1 0 8.8 12 3.2 3.2 0 0 0 12 15.2z" />
    </Svg>
  ),
};

function Field({ label, icon, right, ...props }) {
  return (
    <label className="field">
      <div className="fieldLabel">{label}</div>
      <div className="input">
        <span className="inputLeft">{icon}</span>
        <input className="inputControl" {...props} />
        {right ? <span className="inputRight">{right}</span> : null}
      </div>
    </label>
  );
}

const AdminLogin = ({ onLogin }) => {
  const navigate = useNavigate();

  const role = "SUPER_ADMIN";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
  
    try {
      const res = await fetch(`${API_BASE}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, role }),
      });

      const data = await res.json();
  
      if (res.ok) {
        // attendre 2 secondes avant redirection
        setTimeout(() => {
          onLogin(data.access_token, data.role, data.email);
          navigate("/dashboard/admin");
        }, 1000);
  
      } else {
        setError(data.msg || "Erreur serveur");
        setLoading(false);
      }
  
    } catch {
      setError("Impossible de contacter le serveur.");
      setLoading(false);
    }
  };
  
  return (
    <div className="lp">
      {/* LEFT BLUE PANEL (identique Login) */}
      <aside className="lpLeft fade-in">

        <div className="lpPattern" />
        <div className="lpLeftContent">
          <div className="lpBigIcon">{Icons.calendar({ className: "i iXL" })}</div>
          <h1 className="lpTitle">FormiDoc</h1>
          <p className="lpText">
            Accès sécurisé réservé
            <br />
            au Super Admin
          </p>

          <div className="lpMiniCards">
            <div className="miniCard">
              <div className="miniIcon">{Icons.shield({ className: "i iMD" })}</div>
              <div className="miniTitle">Administration</div>
              <div className="miniSub">Pilotage global</div>
            </div>
          </div>
        </div>
      </aside>

      {/* RIGHT PANEL */}
      <main className="lpRight">
      <div className="panel fade-in">
      <div className="panelTop">
      <div className="panelHeading fade-in fade-delay-1">Connexion Super Admin</div>
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 10 }}>
              <span className="roleIconBox" style={{ width: 42, height: 42 }}>
                {Icons.shield({ className: "i iMD roleSvg" })}
              </span>
              <div>
                <div className="roleTitle" style={{ marginBottom: 2 }}>Espace Administrateur</div>
                <div className="roleSub">Accès complet au système</div>
              </div>
            </div>
          </div>

          {error && <div className="msg msgError">{error}</div>}

          <div className="panelBody">
          <form className="form fade-in fade-delay-2" onSubmit={handleSubmit}>
          <Field
                label="Adresse email"
                type="email"
                placeholder="admin@domaine.fr"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                icon={Icons.mail({ className: "i iSM" })}
                required
              />

              <Field
                label="Mot de passe"
                type={showPwd ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                icon={Icons.lock({ className: "i iSM" })}
                right={
                  <button
                    type="button"
                    className="eyeBtn"
                    onClick={() => setShowPwd((v) => !v)}
                    aria-label={showPwd ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  >
                    {Icons.eye({ className: "i iSM" })}
                  </button>
                }
                required
              />

              <button type="submit" className={`primaryBtn ${loading ? "loading" : ""}`} disabled={loading}>
                {loading ? "Connexion..." : "Se connecter"}
              </button>

              <button
                type="button"
                className="superAdmin"
                onClick={() => navigate("/login")}
              >
                ← Retour au login
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminLogin;
